import { apiClient } from './client'
import type { AuthOrganizationUpdateDto, AuthOrganizationDto, AuthOrganizationCreateDto } from '@/types/authOrganizationBranding'

export const authOrganizationApi = {
    async create(clientCompanyId: string, createDto: AuthOrganizationCreateDto) {
        return apiClient.post<AuthOrganizationDto>(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations`, createDto)
    },
    async getById(clientCompanyId: string, authOrganizationId: string) {
        return apiClient.get<AuthOrganizationDto>(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrganizationId}`)
    },

    async update(clientCompanyId: string, authOrganizationId: string, update: AuthOrganizationUpdateDto, logoFile?: File) {
        // Use multipart form when a file is present
        if (logoFile) {
            const formData = new FormData()
            // Keep JSON structure same key as create for consistency if server aligns later
            formData.append('authOrganizationData', JSON.stringify(update))
            formData.append('logo', logoFile)
            return apiClient.put<AuthOrganizationDto>(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrganizationId}`, formData)
        }
        return apiClient.put<AuthOrganizationDto>(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrganizationId}`, update)
    },

    async getOrgIdByEmail(email: string) {
        const encoded = encodeURIComponent(email.trim())
        return await apiClient.get<string>(`/api/AuthOrganizations/resolve/org-id-by-email?email=${encoded}`)
    },
}
